import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'dropzone', 'prompt', 'selection', 'card']
  static classes = ['dragover']

  reveal() {
    this.cardTarget.classList.add('d-none')
    this.dropzoneTarget.classList.remove('d-none')
  }

  select() {
    const file = this.inputTarget.files?.[0]

    if (file) this.#showSelection(file.name)
    else this.#hideSelection()
  }

  highlight() {
    this.dropzoneTarget.classList.add(...this.dragoverClasses)
  }

  unhighlight() {
    this.dropzoneTarget.classList.remove(...this.dragoverClasses)
  }

  drop(event) {
    this.unhighlight()

    const dropped = event.dataTransfer?.files?.[0]
    if (!dropped) return

    const transfer = new DataTransfer()
    transfer.items.add(dropped)
    this.inputTarget.files = transfer.files

    this.#showSelection(dropped.name)
    this.#notify()
  }

  #showSelection(name) {
    this.selectionTarget.textContent = name
    this.selectionTarget.classList.remove('d-none')
    this.promptTarget.classList.add('d-none')
  }

  #hideSelection() {
    this.selectionTarget.textContent = ''
    this.selectionTarget.classList.add('d-none')
    this.promptTarget.classList.remove('d-none')
  }

  #notify() {
    this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }))
    this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }
}
